import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.map';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/web.dom-collections.iterator';
import { assertType } from 'yaassertion';

function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

/**
 * This error is returned when key is not found in SmartCache
 */
var SmartCacheKeyNotFoundError = /*#__PURE__*/function (_Error) {
  function SmartCacheKeyNotFoundError(message) {
    var _this;
    _this = _Error.call(this, message || "Smart Cache Key Not Found") || this;
    _this.code = "SMART_CACHE_KEY_NOT_FOUND";
    return _this;
  }
  _inheritsLoose(SmartCacheKeyNotFoundError, _Error);
  return SmartCacheKeyNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * maxSize: maximum number of keys that the cache can have
 */
var DEFAULT_CAPACITY = {
  maxSize: 400
};
/**
 * Implementation for browser side LRU cache that can be used across worldready sdk.
 */
var BrowserCache = /*#__PURE__*/function () {
  /**
   * Creates BrowserCache cache object based on options object
   * @param {*} options - Object that contains parameter size
   */
  function BrowserCache(options) {
    if (options === void 0) {
      options = {};
    }
    assertType(options, "options", ["plain object"]);
    this.cache = new Map();
    this.maxSize = options.maxSize || DEFAULT_CAPACITY.maxSize;
  }
  /**
   * Utility function to retrieve a value from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @returns {Any} value that's stored in cache for the corresponding key. It'll return undefined if key is not found.
   */
  var _proto = BrowserCache.prototype;
  _proto.get = function get(key) {
    if (!this.cache.has(key)) {
      throw new SmartCacheKeyNotFoundError(key + " not found in WorldReady SmartCache");
    }
    var val = this.cache.get(key);
    // Adding key to cache to ensure the most recently used key is at end Map
    this.set(key, val);
    return val;
  }
  /**
   * Utility function to set the value in cache.
   * @param {String} key string value that should be used as cache key
   * @param {Any} value value that needs to be stored in cache (can be string, number, object, etc.)
   * @returns {Any} value that's added to the cache
   */;
  _proto.set = function set(key, value) {
    // Remove key if present so that the most recently used key is at end Map
    this.delete(key);
    if (this.size() === this.maxSize) {
      this.delete(this.cache.keys().next().value);
      return this.cache.set(key, value);
    } else {
      return this.cache.set(key, value);
    }
  }
  /**
   * Utility function to delete a key from cache.
   * @param {String} key string value that was used as key while entering the value in cache
   * @returns {Boolean} true if key was found, otherwise false
   */;
  _proto.delete = function _delete(key) {
    return this.cache.delete(key);
  }
  /**
   * Utility function to check if value for a certain key is present in cache or not.
   * @param {*} key string value that could've been used as key while entering the value in cache
   * @returns {Boolean}
   */;
  _proto.has = function has(key) {
    return this.cache.has(key);
  }
  /**
   * Helper function to clear contents of cache.
   */;
  _proto.clear = function clear() {
    this.cache = new Map();
  }
  /**
   * Utility function to get total number of items present in cache.
   */;
  _proto.size = function size() {
    return this.cache.size;
  };
  return BrowserCache;
}();

export { BrowserCache as SmartCache };
